import { BrowserRouter as Router } from 'react-router-dom'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Services from './components/Services'
import Projects from './components/Projects'
import Tutorial from './components/Tutorial'
import Team from './components/Team'
import Contact from './components/Contact'
import Footer from './components/Footer'
import FloatingSocial from './components/FloatingSocial'
import ScrollToTop from './components/ScrollToTop'

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <Projects />
          <Tutorial />
          <Team />
          <Contact />
        </main>
        <Footer />
        <FloatingSocial />
        <ScrollToTop />
      </div>
    </Router>
  )
}

export default App
